<div class="tp">
  <input
    #input
    class="tp__input"
    type="text"
    [formControl]="control"
    [matAutocomplete]="auto"
    [placeholder]="placeholder"
    (keydown.enter)="onEnter($event)"
    (keydown.escape)="dismiss.emit()"
    (blur)="onBlur()"
  />

  <!-- Material owns the overlay: keyboard navigation, ARIA roles and flipping
       upward when there is no room below. -->
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayEmpty"
    [class]="panelClasses"
    [panelWidth]="PANEL_WIDTH"
    (optionSelected)="onSelected($event.option.value)"
  >
    <!-- Leads the list and stays there however long the results run, and arrow
         keys reach it like any other option. -->
    <mat-option
      class="tp__action"
      *ngIf="canCommitFreeText"
      [value]="{ freeText: draft.trim() }"
    >
      <span class="tp__opt">
        <span class="tp__opt-l">
          <span class="tp__opt-name"
            >Add “<strong>{{ draft.trim() }}</strong
            >” as free text</span
          >
        </span>
        <span class="tp__opt-r"><span class="tp__col-count">text</span></span>
      </span>
      <span class="tp__hint"
        >matches the words anywhere — no entity resolution</span
      >
    </mat-option>

    <mat-option class="tp__status" *ngIf="browsingArtifacts" disabled>
      {{ browseNote }}
    </mat-option>

    <mat-optgroup *ngFor="let group of groups; trackBy: trackByGroup">
      <div class="tp__group-head">
        <span>{{ group.name }}</span>
        <!-- Only the count is captioned: a two-letter country code needs no
             header, and two captions collide in a panel this narrow. -->
        <span class="tp__group-cols" *ngIf="group.options[0].country != null">
          <span class="tp__col-count">Articles</span>
        </span>
      </div>
      <mat-option
        *ngFor="let option of group.options; trackBy: trackByOption"
        [value]="option"
      >
        <span class="tp__opt">
          <span class="tp__opt-l">
            <span class="tp__opt-name" [title]="option.name">{{
              option.name
            }}</span>
            <span class="tp__opt-meta" *ngIf="option.meta">{{
              option.meta
            }}</span>
          </span>
          <span class="tp__opt-r">
            <span class="tp__col-country">{{ option.country }}</span>
            <span class="tp__col-count">{{ countLabel(option.count) }}</span>
          </span>
        </span>
      </mat-option>
    </mat-optgroup>

    <mat-option class="tp__status" *ngIf="loading" disabled>
      Searching…
    </mat-option>
    <mat-option class="tp__status" *ngIf="failed && !loading" disabled>
      Lookup unavailable — you can still add this as free text.
    </mat-option>
  </mat-autocomplete>
</div>
